import stickybits from 'stickybits';

document.addEventListener('DOMContentLoaded', () => {
  stickybits('[data-sticky-backtotop]', {
    verticalPosition: 'bottom',
    useFixed: true,
    stickyBitStickyOffset: 40,
    parentClass: 'back-to-top__parent',
    stuckClass: 'back-to-top--stuck',
    stickyClass: 'back-to-top--sticky',
    stickyChangeClass: 'back-to-top--change',
  });
});
